/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Accordion_SellerInputs */

const id_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual`)
};

const ms_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual`)
};

const da_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sælger`)
};

const de_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer`)
};

const en_us2_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller`)
};

const es_es2_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const es_mx2_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const fil_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagbebenta`)
};

const fr_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendeur`)
};

const it_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venditore`)
};

const hu_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eladó`)
};

const nl_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkoper`)
};

const no_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selger`)
};

const pl_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedawca`)
};

const pt_br2_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const pt_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const ro_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vânzător`)
};

const fi_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myyjä`)
};

const sv_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säljare`)
};

const vi_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người bán`)
};

const tr_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satıcı`)
};

const cs_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodejce`)
};

const bg_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавач`)
};

const ru_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавец`)
};

const uk_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавець`)
};

const ar_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البائع`)
};

const hi_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विक्रेता`)
};

const th_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ขาย`)
};

const ja_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売元`)
};

const zh_cn2_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卖家`)
};

const zh_hant1_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賣家`)
};

const ko_search_accordion_seller = /** @type {(inputs: Search_Accordion_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매자`)
};

/**
* | output |
* | --- |
* | "Seller" |
*
* @param {Search_Accordion_SellerInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_accordion_seller = /** @type {((inputs?: Search_Accordion_SellerInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Accordion_SellerInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_accordion_seller(inputs)
	if (locale === "ms") return ms_search_accordion_seller(inputs)
	if (locale === "da") return da_search_accordion_seller(inputs)
	if (locale === "de") return de_search_accordion_seller(inputs)
	if (locale === "en-US") return en_us2_search_accordion_seller(inputs)
	if (locale === "es-ES") return es_es2_search_accordion_seller(inputs)
	if (locale === "es-MX") return es_mx2_search_accordion_seller(inputs)
	if (locale === "fil") return fil_search_accordion_seller(inputs)
	if (locale === "fr") return fr_search_accordion_seller(inputs)
	if (locale === "it") return it_search_accordion_seller(inputs)
	if (locale === "hu") return hu_search_accordion_seller(inputs)
	if (locale === "nl") return nl_search_accordion_seller(inputs)
	if (locale === "no") return no_search_accordion_seller(inputs)
	if (locale === "pl") return pl_search_accordion_seller(inputs)
	if (locale === "pt-BR") return pt_br2_search_accordion_seller(inputs)
	if (locale === "pt") return pt_search_accordion_seller(inputs)
	if (locale === "ro") return ro_search_accordion_seller(inputs)
	if (locale === "fi") return fi_search_accordion_seller(inputs)
	if (locale === "sv") return sv_search_accordion_seller(inputs)
	if (locale === "vi") return vi_search_accordion_seller(inputs)
	if (locale === "tr") return tr_search_accordion_seller(inputs)
	if (locale === "cs") return cs_search_accordion_seller(inputs)
	if (locale === "bg") return bg_search_accordion_seller(inputs)
	if (locale === "ru") return ru_search_accordion_seller(inputs)
	if (locale === "uk") return uk_search_accordion_seller(inputs)
	if (locale === "ar") return ar_search_accordion_seller(inputs)
	if (locale === "hi") return hi_search_accordion_seller(inputs)
	if (locale === "th") return th_search_accordion_seller(inputs)
	if (locale === "ja") return ja_search_accordion_seller(inputs)
	if (locale === "zh-CN") return zh_cn2_search_accordion_seller(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_accordion_seller(inputs)
	return ko_search_accordion_seller(inputs)
});
export { search_accordion_seller as "search.accordion.seller" }